import React, { useContext, useEffect, useState } from "react";
import { Col, Row, Tab, Tabs } from "react-bootstrap";
import { PositionDto } from "../../../../dtos/catalogs/position/PositionDto";
import { CatalogModalViewHeader } from "../../../Shared/CatalogModalViewHeader";
import { NFTextInput } from "../../../Shared/NewForms/NFTextInput";
import { FormProvider, useForm } from "react-hook-form";
import { NewCatalogModalViewContext } from "../../../Shared/NewCatalogModalView";
import { NFDateInput } from "../../../Shared/NewForms/NFDateInput";
import { NFLookupInput } from "../../../Shared/NewForms/NFLookupInput";
import { NFLookupCompany } from "../../../Shared/NewForms/NFLookupCompany";
import { NFLookupDivision } from "../../../Shared/NewForms/NFLookupDivision";
import PositionDetailSkeleton from "./PositionDetailSkeleton";
import {DocumentSaveActionType} from "../../../../helpers/DocumentHelper";

interface IProps {
  model: PositionDto | null;
  modelUpdatedEvent: (newModel: PositionDto) => void;
}

interface PositionModel {
  id: string;
  name: string;
  companyId?: string;
  divisionId?: string;
  description?: string;
  positionApproved?: boolean;
  dateOfApproval?: Date;
  mainSalary?: number;
  mainWorkScheduleId?: string;
}

export const PositionDetail = ({ model, modelUpdatedEvent }: IProps) => {
  const ApprovedNotApproved = [
    { id: 0, name: "True" },
    { id: 1, name: "False" },
  ];
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
    formState,
    getValues,
    watch,
    control,
    trigger,
    ...methods
  } = useForm<PositionModel>();

  const modalViewContext = useContext(NewCatalogModalViewContext);
  const { saveHandler, closeHandler } = modalViewContext;
  const [tabIndex, setTabIndex] = useState(0);

  useEffect(() => {
    if (model) {
      setValue("id", model.id);
      setValue("name", model.name);
      setValue("companyId", model.companyId);
      setValue("divisionId", model.divisionId);
      setValue("description", model.description);
      setValue("positionApproved", model.positionApproved);
      setValue("dateOfApproval", model.dateOfApproval);
      setValue("mainSalary", model.mainSalary);
      setValue("mainWorkScheduleId", model.mainWorkScheduleId);
    }
  }, [model]);

  const handleFormSubmit = async (action: DocumentSaveActionType, data: PositionModel) => {
    console.log("form submit start");
    console.log(data);
    console.log(action);
    // return;
    if (action === "save") {
      const newModel: PositionDto = { ...model, ...data };
      console.log("new model");
      console.log(newModel);
      // if (modelUpdatedEvent) modelUpdatedEvent(newModel);
      await saveHandler(newModel);
    }
    console.log("form submit finish");
  };

  if (!model) {
    return (
      <>
        <PositionDetailSkeleton />
      </>
    );
  }
  const handleTabChange = (index: number) => {
    setTabIndex(index);
  };

  return (
    <>
      <FormProvider
        getValues={getValues}
        setValue={setValue}
        register={register}
        control={control}
        trigger={trigger}
        reset={reset}
        watch={watch}
        handleSubmit={handleSubmit}
        formState={formState}
        {...methods}
      >
        <div className="d-flex" style={{ gap: "12px" }}>
          <button
            onClick={() => handleTabChange(0)}
            className={`btn me-2 ${
              tabIndex === 0 ? "custom-btn" : "btn btn-light"
            }`}
          >
            Main
          </button>
          <button
            onClick={() => handleTabChange(1)}
            className={`btn ${tabIndex === 1 ? "custom-btn" : "btn btn-light"}`}
          >
            Additional
          </button>
        </div>

        <CatalogModalViewHeader
          onSave={handleSubmit((data) => handleFormSubmit("save", data))}
          onClose={closeHandler}
        />
        <div className="panel panel-primary tabs-style-2">
          <div className=" tab-menu-heading">
            <div className="tabs-menu1">
              {/* <!-- Tabs --> */}
              <Tabs
                defaultActiveKey="0"
                activeKey={tabIndex}
                className=" panel-tabs main-nav-line "
              >
                <Tab eventKey="0" title={undefined}>
                  <div
                    className={
                      "panel-body tabs-menu-body main-content-body-right"
                    }
                  >
                    <Row>
                      <Col sm={6}>
                        <NFTextInput title={"Name"} fieldName={"name"} />
                      </Col>
                      <Col sm={6}>
                        <NFTextInput
                          title={"Unique code"}
                          fieldName={"uniqueCode"}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col sm={6}>
                        <NFTextInput
                          fieldName={"description"}
                          title={"Description"}
                        />
                      </Col>
                      <Col sm={6}>
                        <NFDateInput
                          fieldName={"dateOfApproval"}
                          title={"Date of Approval"}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col sm={6}>
                        <NFLookupInput
                          fieldName={"positionApproved"}
                          title={"Position Approved"}
                          items={ApprovedNotApproved}
                        />
                      </Col>
                      <Col sm={6}>
                        <NFTextInput
                          fieldName={"mainSalary"}
                          title={"Main Salary"}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col sm={6}>
                        <NFLookupCompany
                          fieldName={"companyId"}
                          title={"Company"}
                        />
                      </Col>
                      <Col sm={6}>
                        <NFLookupDivision
                          fieldName={"divisionId"}
                          title={"Division"}
                        />
                      </Col>
                      <Col sm={6}>
                        <NFTextInput
                          fieldName={"mainWorkScheduleId"}
                          title={"mainWorkScheduleId"}
                        />
                      </Col>
                    </Row>
                  </div>
                </Tab>

                {/*  */}
                <Tab eventKey="1" title={undefined}>
                  <div
                    className={
                      "panel-body tabs-menu-body main-content-body-right"
                    }
                  >
                    <Row>
                      <Col sm={12}>
                        <NFTextInput title={"Email"} fieldName={"email"} />
                      </Col>
                    </Row>
                  </div>
                </Tab>
              </Tabs>
            </div>
          </div>
        </div>
      </FormProvider>
    </>
  );
};
